import * as Yup from 'yup'

export const setorSchema = Yup.object().shape({
  nome: Yup.string().required('Nome é obrigatório'),
})
